import { colorsList } from "./colorsList";

export const screensList = {
  territories: { width: 0, color: colorsList.violet },
  addresses: { width: 0, color: colorsList.red },
  groups: { width: 0, color: colorsList.purple },
  map: { width: 0, color: colorsList.green },
  schedule: { width: 100, color: colorsList.blue },
  settings: { width: 0, color: colorsList.violet },
  mood: { color: colorsList.orange },
  logout: { color: colorsList.red },
  // help: { width: 0, color: "#2E45D6" },
};
